import classNames from 'classnames'
import * as React from 'react'

import Icon from 'components/Icon'
import { UI } from 'Icon/ui'

import './List.scss'

interface ListProps {
  borderType?: string
  horizontal?: boolean
  highlight?: boolean
  isText?: boolean
  children?: React.ReactNode | undefined
}

interface ListItemProps {
  icon?: boolean
  dash?: boolean
  iconSide?: string
  iconColored?: boolean
  children?: React.ReactNode | undefined
}

const List: React.FC<ListProps> = props => {
  const className = classNames(
    'srprs-list',
    `border-${props.borderType}`,
    props.horizontal ? 'type-horizontal' : '',
    props.highlight ? 'highlight' : '',
    props.isText ? 'is-text' : '',
  )
  return <ul className={className}>{props.children}</ul>
}

const ListItem: React.FC<ListItemProps> = props => {
  const iconSideClass: string = !props.icon
    ? ''
    : props.iconSide && props.iconSide === 'right'
    ? 'icon-side-right'
    : 'icon-side-left'
  const iconColoredClass: string = props.iconColored ? 'icon-colored' : ''
  return (
    <li className={`${iconSideClass} ${iconColoredClass}`}>
      {!props.icon || props.dash ? '' : <Icon icon={UI.check} />}
      {props.dash ? <span className="list-dash">-</span> : ''}
      <span>{props.children}</span>
    </li>
  )
}

List.defaultProps = {
  borderType: 'none',
  horizontal: false,
}

ListItem.defaultProps = {
  icon: true,
  iconSide: 'left',
  iconColored: false,
}

export { List, ListItem }
